module.exports = __webpack_public_path__ + "admin/img/module_icon_light.2526eb79.svg";